import React, { useState, useEffect, useRef } from 'react';

const GalleryMasonry = ({ images, onImageClick }) => {
  const [columns, setColumns] = useState(2);
  const containerRef = useRef(null);

  useEffect(() => {
    const updateColumns = () => {
      if (!containerRef.current) return;
      const width = containerRef.current.offsetWidth;

      let cols;
      if (width < 500) cols = 1;
      else if (width < 900) cols = 2;
      else cols = 3;

      // Never more columns than images
      setColumns(Math.min(cols, images.length));
    };

    updateColumns();
    window.addEventListener('resize', updateColumns);
    return () => window.removeEventListener('resize', updateColumns);
  }, [images.length]);

  // Distribute images into columns (round-robin)
  const columnArrays = Array.from({ length: columns }, () => []);
  images.forEach((image, index) => {
    columnArrays[index % columns].push(image);
  });

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        gap: '16px',
        justifyContent: 'center',
        maxWidth: images.length === 1 ? '500px' : images.length === 2 ? '700px' : 'none',
        margin: images.length <= 2 ? '0 auto' : undefined,
      }}
    >
      {columnArrays.map((columnImages, columnIndex) => (
        <div
          key={columnIndex}
          style={{
            flex: '1 1 0%',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          {columnImages.map((image) => {
            const position = image.imagePosition || { x: 0, y: 0 };
            const objectPosition = `50% ${50 + position.y}%`;
            return (
              <div
                key={image.id}
                className="relative group overflow-hidden rounded-lg bg-gray-100 cursor-pointer"
                onClick={() => onImageClick(images.indexOf(image))}
                onMouseEnter={(e) => e.stopPropagation()}
                onMouseLeave={(e) => e.stopPropagation()}
              >
                <img
                  src={image.imageUrl}
                  alt={image.altText}
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    objectPosition,
                    transition: 'transform 0.3s ease',
                  }}
                  className="group-hover:scale-105"
                />
                {image.caption && (
                  <div
                    className="opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
                      padding: '16px',
                    }}
                  >
                    <p style={{ color: '#FFFFFF', fontSize: '14px' }}>{image.caption}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default GalleryMasonry;
